import AppLayout from "./AppLayout";
import LoginLayout from "./LoginLayout";

const layouts = {
	App: AppLayout,
	Login: LoginLayout,
};

export default layouts;
